import { Bundle, Prisma } from '@prisma/client';
import { RuleObject } from 'antd/es/form';

import { useFindBundleFetch } from '../../data';

export const useNameIsUniqueRule = () => {
  const findBundle = useFindBundleFetch();

  const nameIsUniqueRule = (bundleId?: number) => {
    return (_rule: RuleObject, value: string) => {
      return new Promise((resolve, reject) => {
        if (!value || value.length <= 5) {
          resolve('');
        }

        const params: Prisma.BundleFindManyArgs = {
          where: {
            name: value,
          },
          select: { id: true, name: true },
        };

        findBundle<Bundle>(params)
          .then((result) => {
            if (result.count === 0) {
              resolve('');
            } else if (result.data[0].id === bundleId) {
              resolve(''); // matches itself
            } else {
              reject('Name is not unique, please try another.');
            }
          })
          .catch((error) => {
            console.log(error);
            reject('Error: unable to determine if name is unique.');
          });
      });
    };
  };

  return nameIsUniqueRule;
};
